export default __webpack_public_path__ + "static/media/toggle-arrow.4cb99ac4.svg";